import React, { useState, useEffect } from 'react';
import { useReturnContext } from '../context/ReturnContext';
import './NotesForm.css';

export default function NotesForm({ onNotesSubmitted, onBack }) {
  const { notes: contextNotes, setNotes: setContextNotes } = useReturnContext();
  const [localNotes, setLocalNotes] = useState(contextNotes || '');
  const maxLength = 500;
  
  // Update local state when context changes
  useEffect(() => {
    setLocalNotes(contextNotes || '');
  }, [contextNotes]);
  
  // Update context when local state changes
  useEffect(() => {
    setContextNotes(localNotes);
  }, [localNotes, setContextNotes]);

  const handleContinue = () => {
    onNotesSubmitted(localNotes);
  };

  return (
    <div className="notes-form">
      <h2 className="section-title">Additional Notes</h2>
      <p className="mb-6 text-gray-600">
        Please provide any additional information about your return or exchange request.
      </p>
      
      <div className="card">
        <div className="card-body">
          <div className="form-group">
            <label htmlFor="notes" className="form-label">
              Notes (optional)
            </label>
            <textarea
              id="notes"
              className="form-control"
              value={localNotes}
              onChange={(e) => setLocalNotes(e.target.value)}
              placeholder="Please describe the reason for your return or exchange, or any other details we should know."
              rows={5}
              maxLength={maxLength}
            ></textarea>
            <div className="character-count">
              {localNotes.length}/{maxLength} characters
            </div>
            <small className="form-text">
              This information helps us process your request more efficiently.
            </small>
          </div>
        </div>
      </div>
      
      <div className="d-flex justify-content-between mt-4">
        <button 
          type="button" 
          className="btn btn-secondary"
          onClick={onBack}
        >
          <i className="fas fa-arrow-left mr-2"></i> Back
        </button>
        <button 
          type="button" 
          className="btn btn-primary"
          onClick={handleContinue}
        >
          Continue <i className="fas fa-arrow-right ml-2"></i>
        </button>
      </div>
    </div>
  );
}
